import { action, makeObservable, observable } from 'mobx';
import MatchMedia, {TListener}  from '@tolkam/lib-match-media';
import { IMessageParams, Translator } from '@tolkam/lib-translator';
import { Renderer } from '@tolkam/lib-react-renderer';

class UiStore {

    /**
     * Global message
     */
    public message: {
        text: string,
        type: 'error' | 'success' | 'info',
    } | null = {
        text: 'test',
        type: 'error'
    };

    /**
     * Display properties
     */
    public display: Partial<{
        mouse: boolean;
        s: boolean;
        m: boolean;
        l: boolean;
        xl: boolean;
        sOnly: boolean;
        mOnly: boolean;
        lOnly: boolean;
    }> = {
        s: true, // s by default
    };

    public constructor(
        protected matchMedia: MatchMedia,
        protected translator: Translator,
        protected elementRenderer: Renderer
    ) {

        makeObservable(this, {
            message: observable,
            display: observable,
            setMessage: action,
            clearMessage: action,
        });

        matchMedia.listen(this.listenMatchMedia);
    }

    /**
     * Sets global message
     *
     * @param text
     * @param type
     *
     * @return void
     */
    public setMessage = (
        text: NonNullable<IUiStore['message']>['text'],
        type: NonNullable<IUiStore['message']>['type']
    ): void => {
        this.message = {text, type};
    }

    /**
     * Clears the global message
     *
     * @return void
     */
    public clearMessage = (): void => {
        this.message = null;
    }

    /**
     * Translates string with preconfigured Translator
     */
    public t = (messageCode: string, params?: IMessageParams): string => {
        return this.translator.get(messageCode, params) as string;
    }

    /**
     * Re-renders elements within specified container
     *
     * @param container
     */
    public reRender = (container: HTMLElement) => {
        this.elementRenderer.mount(container);
    }

    /**
     * Listens match media changes and sets state
     *
     * @param matches
     */
    private listenMatchMedia: TListener = action(matches => {
        this.display = matches;
    })
}

interface IUiStore extends UiStore {}

export default UiStore;
